import React, { FC } from 'react';
import { useToast } from '@/hooks';
import { ToastData } from '@/context/ToastProvider/types';
import { Toast } from './Toast';
import { ToastsList } from './styled';

export const Toasts: FC = () => {
  const { toasts } = useToast();

  if (!toasts?.length) return null;

  return (
    <ToastsList data-testid="toasts-container">
      {toasts.map((toast: ToastData) => (
        <Toast
          type={toast.type}
          title={toast.title}
          description={toast.description}
          key={toast.id}
          timeout={toast.timeout}
        />
      ))}
    </ToastsList>
  );
};
